<template>
  <div class="row">
    <div class="col-6">
      <b-form-group label="Funcionario Loteador">
        <b-input-group class="input-group-merge">
          <b-input-group-prepend is-text>
            <feather-icon icon="UserIcon" />
          </b-input-group-prepend>
          <b-form-input
            v-model="currentUser.nombre"
            readonly
            placeholder="Funcionario Loteador"
          />
        </b-input-group>
      </b-form-group>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      preIssue: this.value || {}
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
